"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("core-js/modules/es6.object.assign");
function _templateObject() {
    var data = _taggedTemplateLiteralLoose([""]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) {
    raw = strings.slice(0);
} strings.raw = raw; return strings; }
const react_1 = __importDefault(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const Entry_1 = __importDefault(require("./Entry"));
var SectionStyledEducation = styled_1.default.section(_templateObject());
var SectionEducation = function SectionEducation(_ref) {
    var education = _ref.education;
    return /*#__PURE__*/ react_1.default.createElement(SectionStyledEducation, null, /*#__PURE__*/ react_1.default.createElement("h2", null, "Education"), education.map(function (e, i) {
        return /*#__PURE__*/ react_1.default.createElement(Entry_1.default, Object.assign({
            key: e.title + i
        }, e));
    }));
};
exports.default = SectionEducation;
